import { PermissionT } from "../types";

export const hasVisionAccess = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "has_vision_access");
  return !!p;
};

export default hasVisionAccess;
